import { Component, OnInit } from '@angular/core';
import { CountService } from './services/count/count.service';
import { DataStorageService } from './services/data-storage/data-storage.service';
declare var $:any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  constructor(private dataStorage:DataStorageService,private countService:CountService){}
  onActivate(event) {
    window.scroll(0,0);
    //or document.body.scrollTop = 0;
    //or document.querySelector('body').scrollTo(0,0)
    
  }
  ngOnInit(){
    // $("#myModal").modal('show');
    this.countService.fetchCount();
    // this.countService.UpdateCount();
    this.dataStorage.fetchBulletin();

  }
}
